export const featuredTestimonial = {
  eyebrow: 'What parents tell us',
  quote:
    '“We toured six schools. This was the only one where the children looked up and waved at us.”',
  name: 'Mrs. Ifeoma Okafor',
  detail: 'mother of two · Primary 2 & Grade 7',
};

export const testimonials = [
  {
    quote: '“She asks to go to school on Saturdays. I have stopped explaining weekends.”',
    attribution: 'Daniel A. · father, Toddler Room',
    tone: 'white',
  },
  {
    quote:
      "“They know my son's name, his moods, and his handwriting. At a public school. Free.”",
    attribution: 'Blessing U. · mother, Grade 4',
    tone: 'mint',
  },
];
